import { Link } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const OldVsNewTaxRegimePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />

      <main className="px-6 py-12">
        <article className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-3" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Old vs New Tax Regime: Which Is Better for You?
          </h1>

          <p className="text-sm opacity-60 mb-8">
            Simple guide for Indian taxpayers to understand old and new tax regime before filing ITR.
          </p>

          <div className="space-y-6 text-[15px] leading-7 opacity-90">
            <p>
              While filing your Income Tax Return, one of the most important choices is selecting between the old tax regime and the new tax regime. The right choice depends on your salary, deductions, exemptions, and investments.
            </p>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                What is the Old Tax Regime?
              </h2>
              <p>
                The old tax regime allows common deductions and exemptions such as 80C, 80D, HRA, home loan interest, and other eligible deductions. It may be useful if you claim several deductions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                What is the New Tax Regime?
              </h2>
              <p>
                The new tax regime offers lower slab rates but limits many deductions and exemptions. It may be better for taxpayers who do not claim many deductions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Which Regime Should Salaried Individuals Choose?
              </h2>
              <p>
                Salaried individuals should compare both regimes before filing. If you have high deductions under 80C, 80D, HRA, or home loan interest, the old regime may help. If you have fewer deductions, the new regime may be simpler and more beneficial.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Common Mistakes
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Choosing a regime without comparing tax liability</li>
                <li>Missing Form 16 salary details</li>
                <li>Claiming deductions incorrectly</li>
                <li>Confusing tax saving with refund</li>
              </ul>
            </section>

            <div className="rounded-xl p-5" style={{ backgroundColor: "var(--secondary)" }}>
              <h3 className="font-semibold mb-2">Need help choosing the right regime?</h3>
              <p className="mb-4">
                MoolTax helps you organize your documents and complete ITR filing with guided support.
              </p>
              <Link to="/plans" className="inline-block px-5 py-2 rounded-lg text-white" style={{ backgroundColor: "var(--accent)" }}>
                Start Filing
              </Link>
            </div>
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
};

export default OldVsNewTaxRegimePage;